<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Início" v-bind:breadCrumbList="[]" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="banner-preambulo-wrapper" v-for="(banner, index) in banners" :key="index">
        <a :href="banner.url" target="_blank" rel="noopener">
          <img :src="banner.imagem" :alt="banner.alt" class="img-fluid banner-preambulo" />
        </a>
      </div>
      <div class="alert custom-alert-warning alert-dismissible fade show" role="alert" v-if="deveExibirAlertaInadimplencia">
        {{ mensagemAlertaInadimplencia }}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card" v-if="carregandoListaDeConvites">
        <div class="card-header">
          <h3 class="card-title titulos">Convites</h3>
        </div>
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.convites.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.convites.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="row justify-content-center">
            <div v-for="(convite) in listaDeConvites" :key="convite.f_id" class="col-12 col-sm-6 col-md-3">
              <div v-if="convite.f_status == statusConvitePendente">
                <ConvitesPendentes
                  :camposConvite="convite"
                  @retornoDoConvite="salvarRetornoDoConvite"
                  :desabilitar="requisicaoEmAndamento"
                />
              </div>
              <div v-if="convite.f_status == statusNotificacaoCancelamento">
                <ConvitesCancelados
                  :camposConvite="convite"
                  @retornoDoConvite="salvarRetornoDoConvite"
                  :desabilitar="requisicaoEmAndamento"
                />
              </div>
            </div>
            <div v-for="(notificacao) in listaDeNotificacoes" :key="notificacao.f_id" class="col-12 col-sm-6 col-md-3">
              <NotificacoesConvites
                :camposNotificacao="notificacao"
                @retornoDoConvite="salvarRetornoNotificacaoConvite"
                :desabilitar="requisicaoEmAndamento"
              />
            </div>
          </div>
          <div v-if="flagsDeControle.manipulandoDados.convites.status" class="d-flex align-items-center col-md-12">
            <span class="avisoDanger">{{flagsDeControle.manipulandoDados.convites.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
        </div>
      </div>
      <!--card AGENDA -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title titulos">Agenda</h3>
        </div>
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.agenda.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.agenda.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <FullCalendar v-if="!flagsDeControle.carregandoDados.agenda.status" ref="calendarioAgenda" id="calendar" :options="calendarOptions" :disabled="flagsDeControle.carregandoDados.agenda.status"/>
        </div>
      </div>
      <!--card NOTICIAS -->
      <div class="card" v-if="carregandoListaDeNoticias">
        <div class="card-header">
          <h3 class="card-title titulos">Notícias</h3>
        </div>
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.noticias.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.noticias.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="row">
            <div v-for="(campo) in listaNoticias" :key="campo.id" class="col-8 col-sm-6 col-md-3">
              <div class="card bg-light d-flex flex-fill">
                <div class="card-header titulos-conteudo border-bottom-0">{{campo.title}}</div>
                <div class="card-body pt-0">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        <small class="text-muted">{{formatarDataHora(campo.date)}}</small>
                        <br/>
                        <small class="text-muted">Publicado por: {{campo.author}}</small>
                      </p>
                    </div>
                    <div class="col 12">
                      <p class="card-text textos" v-html="campo.summary"></p>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="text-right">
                    <b-button class="botoes" variant="outline-primary btn-sm mr-1" @click="detalhesNoticia(campo.id)" :disabled="flagsDeControle.carregandoDados.noticias.status">Ver</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Inicio from './js'
export default Inicio
</script>

<style scoped>
@import "./scss/inicio.scss";
@import "../../assets/css/fullcalendar/main.css";
@import "../../assets/scss/fullCalendarCustom.scss";
</style>
